import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumPalletStatus implements BaseEnumType {
  private static allValues: EnumPalletStatus[] = []; // make sure this is top-most
  
  public static none = new EnumPalletStatus(0, "None", "enum_pallet_status_none");
  public static in = new EnumPalletStatus(1, "In", "enum_pallet_status_in");
  public static delivered = new EnumPalletStatus(2, "Delivered", "enum_pallet_status_delivered");
  public static disassembled = new EnumPalletStatus(3, "Disassembled", "enum_pallet_status_disassembled");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumPalletStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumPalletStatus.none; }
  public isIn() { return this === EnumPalletStatus.in; }
  public isDelivered() { return this === EnumPalletStatus.delivered; }
  public isDisassembled() { return this === EnumPalletStatus.disassembled; }

  public static getValues(): readonly EnumPalletStatus[] {
    return EnumPalletStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumPalletStatus[] {
    return EnumPalletStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumPalletStatus {
    const found = EnumPalletStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumPalletStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumPalletStatus): EnumPalletStatus {
    const found = name ? EnumPalletStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumPalletStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumPalletStatus>): boolean {
    return this.key === other?.key;
  }
}